import { ISessionStrategy } from 'src/types/module_types_authentication';
import { Hosting } from 'src/core/ahp';

export class NoneSessionStrategy implements ISessionStrategy {
  deactivate(ahp: Hosting) {}

  activate(ahp: Hosting) {
    // the server tracks the session, so we do nothing
  }
}

export const noneSessionStrategy = new NoneSessionStrategy();
